import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import Loader from '../Utility/Loader/Loader';

function AddToLibraries({ onOpen, Toggle, showLoader, codeName, submitCode }) {
  const [code, setCode] = useState(codeName);
  const { t } = useTranslation('common');

  const handleChange = (e) => {
    setCode(e.target.value);
  };

  return (
    <Modal show={onOpen} className="common-custom-modal modal-small-2x color-way-modal" aria-labelledby="contained-modal-title-vcenter">
      <Modal.Header className="modal-header-custom">
        <Modal.Title id="contained-modal-title-vcenter">
          <span>{t('LIBRARY_MODAL.TITLE')}</span>
        </Modal.Title>
        <span onClick={Toggle} className="icon-close f-20 ml-auto cursor-pointer" />
      </Modal.Header>
      <Modal.Body>
        <div className="modal-inner-data">
          {showLoader ? (
            <Loader />
          ) : (
            <div className="common-input-control">
              <input type="text" name="code" placeholder="Enter code" className="form-control" value={code} onChange={(e) => handleChange(e)} />
              {code?.trim().length === 0 && <div className="error-message">{t('LIBRARY_MODAL.ERROR_NAME_MISSING')}</div>}
            </div>
          )}
        </div>
        <div className="common-model-footer">
          <button
            aria-label="yes"
            type="button"
            title={t('LIBRARY_MODAL.BUTTONS.YES')}
            className="btn p-0"
            disabled={code?.trim().length === 0}
            onClick={() => submitCode(code)}
          >
            <i className="icon-Tick-1 f-24" />
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default AddToLibraries;
